
<div class="SiteHeaderWrapper">
    <div
        class="PromotionBar"
        v-if="showPromotion && (!isMobile || !isPromotionClosedMobile)"
        :class="{ 'PromotionBar--bottom': isMobile }"
    >
        <div class="PromotionContent">
            <i class="ri-coupon-2-line"></i>
            <span>
                <b>TSE-COMPLIANCE:</b> Pflicht ab 2026 – jetzt TSE-konform mit uns!
                <b>Aktion:</b> 50% Rabatt auf das Basic Paket - 8€ statt 16€.
            </span>
            <span v-if="isMobile && timeLeftString" class="PromotionCountdown">
                <i class="ri-timer-line"></i>
                {{ timeLeftString }}
            </span>
            <router-link :to="getPromotionRedirectUrl()" class="PromotionButton"
                >Angebot sichern</router-link
            >
            <button
                v-if="isMobile"
                class="PromotionCloseButton"
                @click="closePromotion"
                aria-label="Promotion schließen"
            >
                <i class="ri-close-line"></i>
            </button>
        </div>
    </div>

    <div
        class="SiteHeader"
        :class="{ 'is-scrolled': isScrolled, 'is-hidden': isHidden }"
        :style="headerStyle"
    >
        <div class="SiteHeader-Wrap">
            <router-link to="/" class="Logo">
                <img src="../assets/svg/logo.svg" alt="TaxiFusion Logo" />
            </router-link>

            <nav class="Navigation">
                <!-- Desktop Navigation -->
                <div class="DesktopNav">
                    <component
                        :is="item.isRouterLink ? 'router-link' : 'a'"
                        v-for="(item, index) in regularNavItems"
                        :key="index"
                        :to="item.isRouterLink ? item.url : undefined"
                        :href="!item.isRouterLink ? item.url : undefined"
                        class="NavigationItem"
                        :class="{ isActive: item.active }"
                    >
                        {{ item.label }}
                    </component>
                    <router-link
                        v-if="blogNavItem"
                        class="NavigationItem"
                        :to="blogNavItem.url"
                        :class="{ isActive: blogNavItem.active }"
                        @click.native="trackBlogNavigation('header', 'desktop')"
                    >
                        {{ blogNavItem.label }}
                    </router-link>
                </div>

                <div class="AuthButtons">
                    <router-link to="/register?source=header_desktop" v-if="!isMobile">
                        <SiteButton size="small" variant="outline">
                            Kostenlos registrieren
                        </SiteButton>
                    </router-link>
                    <router-link to="/sign-in">
                        <SiteButton size="small">
                            <i class="ri-login-box-line"></i>
                            Login
                        </SiteButton>
                    </router-link>
                </div>

                <button class="Hamburger" @click="toggleMobileMenu" aria-label="Menu">
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
            </nav>
        </div>

        <transition name="slide-in">
            <div v-if="isMobileMenuOpen" class="MobileMenu">
                <div class="MobileMenuHeader">
                    <div class="BrandingMobile">
                        <img
                            src="../assets/svg/logo.svg"
                            alt="TaxiFusion Logo"
                            class="MobileLogo"
                        />
                        <span class="MobileLogoText">TaxiFusion</span>
                    </div>
                    <button
                        class="MobileMenuClose"
                        @click="closeMobileMenu"
                        aria-label="Close menu"
                    >
                        <i class="ri-close-circle-line"></i>
                    </button>
                </div>

                <div class="MobileNavItems">
                    <component
                        :is="item.isRouterLink ? 'router-link' : 'a'"
                        v-for="(item, index) in regularNavItems"
                        :key="index"
                        :to="item.isRouterLink ? item.url : undefined"
                        :href="!item.isRouterLink ? item.url : undefined"
                        :class="{ isActive: item.active }"
                        @click="handleMobileNavClick(item)"
                        @click.native="item.isRouterLink ? closeMobileMenu : undefined"
                    >
                        {{ item.label }}
                    </component>
                    <router-link
                        v-if="blogNavItem"
                        :to="blogNavItem.url"
                        @click.native="handleBlogClick"
                        :class="{ isActive: blogNavItem.active }"
                    >
                        {{ blogNavItem.label }}
                    </router-link>
                </div>

                <div class="MobileAuthButtons">
                    <router-link
                        to="/register?source=header_mobile"
                        @click.native="closeMobileMenu"
                    >
                        <SiteButton size="small" variant="outline">
                            Kostenlos registrieren
                        </SiteButton>
                    </router-link>
                    <router-link to="/sign-in" @click.native="closeMobileMenu">
                        <SiteButton size="small">
                            <i class="ri-login-box-line"></i>
                            Login
                        </SiteButton>
                    </router-link>
                </div>
            </div>
        </transition>

        <div v-if="isMobileMenuOpen" class="MobileMenuOverlay" @click="closeMobileMenu"></div>
    </div>
</div>
